export default __webpack_public_path__ + "static/media/edit-square-icon-white.0bcdb872.svg";